import { FC } from 'react';
import { SectionHeading } from '../SectionHeading';

export const NotificationSettingsSection: FC = () => {
  return (
    <div className="flex flex-col gap-6">
      <SectionHeading>Notification Settings</SectionHeading>

      <p className="[font-family:var(--font-montserrat)] [font-size:14px] text-(--neutral-black-NB700)">
        Notification settings coming soon.
      </p>
    </div>
  );
};
